import type { DemoKey } from './keys';

export const bn: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'জ্যামিতি · 3D',
  'panel.figure': 'আকৃতি',
  'panel.dims': 'মাত্রা',
  'panel.style': 'চেহারা',
  'panel.lines': 'বিশেষ রেখা',
  'style.body': 'শরীর',
  'style.line': 'রেখা',
  'style.cut': 'ছেদ',
  'style.labels': 'শীর্ষ লেবেল',
  'group.face': 'মুখের কর্ণ / জনক',
  'group.space': 'কর্ণ / অক্ষ / মধ্যমা',
  'split.label': 'ছেদ',
  'btn.animate': 'চালান',
  'btn.reset': 'রিসেট',
  'hint.line1': 'ঘোরাতে টানুন · জুম করতে স্ক্রোল',
  'hint.line2': 'নির্বাচন করতে রেখায় ক্লিক করুন',
  'fig.cuboid': 'আয়তঘন',
  'fig.cube': 'ঘনক',
  'fig.triPrism': 'ত্রিভুজাকার প্রিজম',
  'fig.hexPrism': 'ষড়ভুজাকার প্রিজম',
  'fig.tetrahedron': 'চতুস্তলক',
  'fig.squarePyramid': 'বর্গাকার পিরামিড',
  'fig.cylinder': 'বেলন',
  'fig.cone': 'শঙ্কু',
  'fig.sphere': 'গোলক',
  'fig.frustumPyramid': 'পিরামিডের ছিন্নক',
  'fig.frustumCone': 'শঙ্কুর ছিন্নক',
  'dim.length': 'দৈর্ঘ্য',
  'dim.width': 'প্রস্থ',
  'dim.height': 'উচ্চতা',
  'dim.side': 'বাহু',
  'dim.radius': 'ব্যাসার্ধ',
  'dim.r1': 'নিম্ন ব্যাসার্ধ',
  'dim.r2': 'ঊর্ধ্ব ব্যাসার্ধ',
  'dim.sideBase': 'ভিত্তি বাহু',
  'dim.sideTop': 'ঊর্ধ্ব বাহু',
  'info.face': 'মুখ',
  'info.center': 'কেন্দ্র দিয়ে',
  'info.diagonal': 'কর্ণ',
  'info.axial': 'অক্ষীয় কর্ণ',
  'info.diameter': 'ব্যাস',
  'info.generator': 'জনক',
  'info.axis': 'অক্ষ',
  'info.height': 'উচ্চতা',
  'info.median': 'মধ্যমা',
  'info.apothem': 'অপোথেম',
  'info.diameterBase': 'ভিত্তি ব্যাস',
  'info.diameterTop': 'ঊর্ধ্ব ব্যাস',
};
